<template>
  <ul
    class="tgbContextMenu min-w-[200px] z-[2] block max-w-[500px] list-none bg-producer-slate-surface p-0 text-white shadow-[4px_4px_4px_1px_rgba(0,0,0,0.5)]"
    :style="menuStyles"
    @contextmenu.stop
  >
  <li
      v-for="action in actions"
      :key="action.key"
      class="tgbContextMenuItem block w-full text-inherit hover:bg-producer-slate-chipHover focus:bg-producer-slate-chipHover active:bg-producer-slate-chipHover"
    >
      <slot v-bind="action" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    actions: Array,
    dropDownMenu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      top: '0px',
      left: '0px',
      position: 'fixed',
    };
  },

  computed: {
    menuStyles() {
      const { top, left, position } = this;

      return {
        top: position === 'fixed' ? `calc(${top} + 1rem)` : top,
        left,
        position,
      };
    },
  },

  watch: {
    dropDownMenu: {
      immediate: true,
      handler(options) {
        this.$nextTick(() => {
          if (options) {
            this.position = 'relative';
            return;
          }

          this.$el.focus();
          this.setMenu(event.clientY, event.clientX); // eslint-disable-line
        });
      },
    },
  },

  methods: {
    setMenu(top, left) {
      let newTop = top;
      let newLeft = left;
      const largestHeight = window.innerHeight - this.$el.offsetHeight - 25;
      const largestWidth = window.innerWidth - this.$el.offsetWidth - 25;

      if (top > largestHeight) newTop = largestHeight;
      if (left > largestWidth) newLeft = largestWidth;

      this.top = `${newTop}px`;
      this.left = `${newLeft}px`;
    },
  },
};
</script>

<style>
.tgbContextMenuButton {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 2rem;
  color: inherit;
  text-align: left;
  font-size: 0.8125rem;
  background: transparent;
  border: none;
}

.tgbContextMenuItem {
  padding: 0;
}
</style>
